export function formatLabels(feedbackData, timeRange) {
    return feedbackData.map((item) => {
      if (!item.period) return "Unknown";
  
      if (["month", "last_month"].includes(timeRange)) {
        return item.period.split(":")[0].trim();
      }
  
      if (["week", "last_week"].includes(timeRange)) {
        return item.period.split(" ")[0].slice(0, 3);
      }
  
      if (["year", "last_year"].includes(timeRange)) {
        return item.period.split(" ")[0].slice(0, 3);
      }
  
      if (timeRange === "last_six_months") {
        const [month, year] = item.period.split(" ");
        return `${month.slice(0, 3)} ${year}`;
      }
  
      return item.period;
    });
  }
  